import { SvgIcon, SvgIconProps } from "@mui/material";

export const BookFilledIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="#FFF"
        fill-rule="evenodd"
        d="M12 5a6.365 6.365 0 0 0-8.188-.687A1.982 1.982 0 0 0 3 5.93v12.956c0 .774.825 1.223 1.508.859A6.365 6.365 0 0 1 12 20.864V5a6.365 6.365 0 0 1 8.188-.687c.518.369.812.981.812 1.617v12.956c0 .774-.825 1.224-1.508.859A6.365 6.365 0 0 0 12 20.864"
        clip-rule="evenodd"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12 5a6.365 6.365 0 0 0-8.188-.687A1.982 1.982 0 0 0 3 5.93v12.956c0 .774.825 1.223 1.508.859A6.365 6.365 0 0 1 12 20.864V5a6.365 6.365 0 0 1 8.188-.687c.518.369.812.981.812 1.617v12.956c0 .774-.825 1.224-1.508.859A6.365 6.365 0 0 0 12 20.864"
      />
    </svg>
  </SvgIcon>
);
